import React from "react";
import { Link } from "react-router-dom";
import { Card, Input, Button, Icon } from "../../components";

import { Globals, Constants, Format } from "../../utils";
import { Auth, Sidebar } from "../../services";
import Logo from '../../assets/img/logo.png';
import LogoWhite from '../../assets/img/logo-white.png';
import AppMockup from '../../assets/img/braxo_app_login.jpg';

import { connect } from "react-redux";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      showRedirect: false,
      showPass: false,
      form: {
        email: "",
        password: "",
        terms: false,
        web: true,
      }
    };
  }

  componentDidMount() {
    const { user, history } = this.props;

    if (!user) {
      return;
    }
  }

  /**
   * Event that captures form submission.
   * @param {object} event emitted when submitting the form.
   */

  submit = emitter => {
    emitter.preventDefault();

    const { form } = this.state;

    this.setState({ submitted: true });

    Auth.authenticate(form)
      .then(({ user, token, message }) => {
        const { level_id: roleId } = user;

        if (message !== null) {
          Globals.showWarning(
            message
          );
        }

        this.props.dispatch({
          type: "SET_USER",
          payload: user
        });

        this.props.dispatch({
          type: "SET_ADMIN",
          payload: Globals.setTypeRole(user)
        });

        localStorage.setItem("token", JSON.stringify(token));

        return user;
      })
      .then(user => {
        if (!user) {
          return;
        }

        const { level_id: roleId } = user;

        Sidebar.getModuleByUser(user.id)
          .then(modules => this.setModules(roleId, user, modules))
          .catch(error => console.log({ error: error }))
          .finally(() => this.setState({ submitted: false }));
      })
      .catch(error => {
        Globals.showError(error?.error);
      })
      .finally(() => this.setState({ submitted: false }));
  };

  recoverPass = () => {

  }

  terms = () => {

  }

  /**
   * Set the menu depending on the permissions.
   * @param {int} user role identifier.
   * @param {object} object containing user properties.
   * @param {object} object that contains the module properties.
   */

  setModules = (roleId, user, modules) => {
    const { id: userId } = user;

    switch (roleId) {
      case Constants.ROLE_ADMIN:
        this.props.dispatch({
          type: "SET_SIDEBAR",
          payload: modules
        });

        this.props.history.push('/dashboard');

        return;

      case Constants.ROLE_MODERATOR:
      case Constants.ROLE_MANAGER:
        if (modules.length > 0) {
          this.props.dispatch({
            type: "SET_SIDEBAR",
            payload: modules
          });

          const defaultModule = modules[0]?.path
          this.props.history.push(defaultModule);

          return;
        }
        else {
          Globals.showError('No posee módulos asignados, comuníquese con el usuario Administrador');
        }


      default:
    }
  };

  handleDisabled = () => {
    return this.state.form.email === "" || this.state.form.password === "";
  };

  handleChange = ({ target }) => {
    const { name, value } = target;

    this.setState(state => ({
      form: {
        ...state.form,
        [name]: value
      }
    }));
  };

  render() {
    const { submitted, showRedirect } = this.state;

    return (
      <main className="login-page">
        <div className="login-shell">
          <section className="login-panel">
            <div className="login-content">
              <header className="login-header">
                <img src={Logo} alt="Braxo" className="brand-logo" />
              </header>

              {showRedirect ? (
                <div className="onboard">
                  <Button
                    color="green"
                    block
                    className="primary"
                    onClick={() => this.setState({ showRedirect: false })}
                  >
                    <span>Iniciar Sesión</span>
                  </Button>

                  <div className="row text-center link" style={{ margin: 'auto' }}>
                    <Link className="highlighted" to="/register">
                      <span className="highlighted">Registrarme</span>
                    </Link>
                  </div>
                </div>
              ) : (
                <>
                  <div className="login-heading">
                    <h1>Bienvenido de nuevo <span aria-hidden="true">👋</span></h1>
                    <p>Inicia sesión para continuar gestionando tu negocio de forma inteligente.</p>
                  </div>

                  <form onSubmit={this.submit} noValidate>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">Correo electrónico</label>
                      <div className="input-icon-wrap">
                        <i className="fa fa-envelope-o"></i>
                        <input type="email" className="form-control" id="email" name="email"
                          placeholder="Ingresa tu correo electrónico"
                          autoComplete="email" required
                          value={this.state.form.email}
                          onChange={this.handleChange} />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">Contraseña</label>
                      <div className="input-icon-wrap password-wrap">
                        <i className="fa fa-lock"></i>
                        <input type={this.state.showPass ? "text" : "password"} className="form-control" id="password" name="password"
                          placeholder="Ingresa tu contraseña"
                          minLength="6" autoComplete="current-password" required
                          value={this.state.form.password}
                          onChange={this.handleChange} />
                        <button type="button" className="password-toggle" onClick={() => this.setState({ showPass: !this.state.showPass })}>
                          <i className={this.state.showPass ? "fa fa-eye-slash" : "fa fa-eye"}></i><span>{this.state.showPass ? "Ocultar" : "Mostrar"}</span>
                        </button>
                      </div>
                    </div>

                    <div className="login-options">
                      <div className="form-check">
                      </div>
                      <Link to="/recover" className="forgot-link">¿Olvidaste tu contraseña?</Link>
                    </div>

                    <button className="login-button w-100" type="submit" disabled={submitted}>Iniciar sesión</button>

                    {/* 
                    <div className="social-separator"><span>O inicia sesión con</span></div>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <button type="button" className="social-login-btn w-100">
                          <span className="google-icon">G</span> Google
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button type="button" className="social-login-btn w-100">
                          <i className="fa fa-facebook-official facebook-icon"></i> Facebook
                        </button>
                      </div>
                    </div>
                    */}

                    <div className="register-sticky">
                      <p style={{ fontSize: '16px' }} className="register-text text-center mb-0">
                        ¿No tienes una cuenta? <Link to="/register">Regístrate</Link>
                      </p>
                    </div>
                  </form>

                  <footer className="login-footer">
                    <div className="security-note">
                      <div className="footer-icon security-icon"><i className="fa fa-shield"></i></div>
                      <p>Tu información está protegida con los más altos estándares de seguridad.</p>
                    </div>
                    <div className="footer-divider"></div>
                    <div className="support-note">
                      <div>
                        <p className="mb-0">¿Necesitas ayuda?</p>

                        <a href="https://wa.me/+584120867446">Contactar soporte</a>
                      </div>
                      <div className="footer-icon support-icon"><i className="fa fa-headphones"></i></div>
                    </div>
                  </footer>
                </>
              )}
            </div>
          </section>

          <aside className="visual-panel">
            <img className="img-fluid" src={AppMockup} alt="Braxo, plataforma para gestionar fuerza de ventas" />
          </aside>
        </div>
      </main>
    );
  }
}

export default connect(state => {
  return {
    user: state.user,
    admin: state.admin
  };
})(Login);
